import React from 'react'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

const SpinnerAdornment = (props) => (
  <CircularProgress
    style={{marginRight: '10px'}}
    size={20}
  />
)

export default function LoadingButton(props) {
  const {
    children,
    loading,
    buttonStyle,
    ...rest
  } = props
  return (
    <Button
      style={{minWidth: '300px', ...buttonStyle}}
      {...rest}
      {...(loading && {disabled: true})}
    >
      {loading && <SpinnerAdornment {...rest} />}
      {children}
    </Button>
  )
}